import './bootstrap'
import page_common from './pages/front/common'
import page_home from './pages/front/home'
import page_product from './pages/front/product'
import page_editor from './pages/front/editor'
import page_contact from './pages/front/contact'
import page_privacy from './pages/front/privacy'
import page_company from './pages/front/company'
import page_terms from './pages/front/terms'
import page_list from './pages/front/list'

import './pages/front/pc'
window.addEventListener('load', () => {
    page_common()
    page_home()
    page_product()
    page_editor()
    page_contact()
    page_privacy()
    page_company()
    page_terms()
    page_list()
});